import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {TaskService} from '../../../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';

@Component({
  selector: 'app-common-audit-create-task',
  templateUrl: './common-audit-create-task.component.html',
  styleUrls: ['../parts.css']
})
export class CommonAuditCreateTaskComponent implements OnInit {

  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  statusList = [
    {code: 'ACTIVE', name: '处理中'},
    {code: 'SUSPENDED', name: '暂停'},
    {code: 'COMPLETED', name: '正常结束'},
    {code: 'INTERNALLY_TERMINATED', name: '终止'},
    {code: 'EXTERNALLY_TERMINATED', name: '终止(外部)'}
  ];

  // 稽核面板
  boardConditionVisible = false;
  boardConditionId;
  boardConditionDisplayText = '面板';
  boardConditionList = [];

  // 稽核项
  itemConditionVisible: boolean; // 流程POP是否关闭
  itemConditionId = null; // 流程选中ID
  itemConditionDisplayText = '稽核项';
  itemConditionList = [];

  statusDisplayText = '状态';
  statusConditionVisible = false;
  statusConditionCode = '';
  // 分组
  groupConditionVisible: boolean; // 分组POP是否关闭
  groupConditionId = null; // 分组选中ID
  groupConditionDisplayText = '分组';
  // 其他
  isVisible = false; // 弹窗显示控制
  isConfirmLoading = false; // 确定按钮
  recipe;
  recipeId = null; // 自动化模板ID
  relationId;
  instanceData: any = {}; // 存放实例返填数据
  categorieId: string; // 存放当前目录ID
  backFillData: any;
  automation = {
    boardId: '',
    boardConditionId: '',
    boardConditionName: '',
    groupId: '',
    categoryId: '',
    relationId: '',
    itemId: '',
    itemName: '',
    auditStatus: '',
    instanceDescription: '',
    taskMapping: {}
  }; // 存放入参数据
  @ViewChild('pulseCard', { static: true }) pulseCard: any;
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private taskService: TaskService,
    private message: NzMessageService
  ) { }

  ngOnInit(): void {
    if (this.recipe && this.recipe['queryBoardList']) {
      this.taskService.queryAuditBoardList(this.recipe['queryBoardList']).subscribe((res: any) => {
        if (res) {
          if (res['_embedded'] && res['_embedded']['vos']) {
            for (const item of res['_embedded']['vos']) {
              if (item.auditBoards) {
                this.boardConditionList.push(...item.auditBoards);
              }
            }
          }
        } else {
          this.message.error('查询稽核面板列表异常');
        }
      });
    } else {
      this.message.info('未配置稽核面板列表查询接口信息，请联系管理员！');
    }
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
    }
    // 处理返填数据
    if (this.instanceData && this.instanceData.config) {
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      console.log(this.automation);
      this.backFillData = this.automation.taskMapping;
      this.boardConditionId = this.automation.boardConditionId;
      this.boardConditionDisplayText = this.automation.boardConditionName;
      this.itemConditionId = this.automation.itemId;
      this.itemConditionDisplayText = this.automation.itemName;
      this.statusConditionCode = this.automation.auditStatus;
      this.queryItemList();
      this.groupConditionId = this.automation.groupId;
      for (const item of this.statusList) {
        if (this.statusConditionCode == item.code) {
          this.statusDisplayText = item.name;
          break;
        }
      }
      for (const item of this.boardGroupData) {
        if (item.id === this.groupConditionId) {
          this.groupConditionDisplayText = item.title;
          break;
        }
      }
    }
    // 带入菜单ID
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    this.packageData();
  }

  boardConditionChange(item) {
    this.boardConditionDisplayText = item.name;
    this.boardConditionId = item.id;
    this.automation.boardConditionId = item.id;
    this.automation.boardConditionName = item.name;
    this.boardConditionVisible = false;
    this.itemConditionId = null;
    this.itemConditionDisplayText = '稽核项';
    this.queryItemList();
    this.packageData();
  }

  queryItemList() {
    if (this.recipe && this.recipe['queryAuditItemList']) {
      this.taskService.queryAuditItemList(this.boardConditionId, this.recipe['queryAuditItemList']).subscribe((res: any) => {
        if (res) {
          console.log(res);
          if (res['_embedded'] && res['_embedded']['vos']) {
            this.itemConditionList = res['_embedded']['vos'];
          }
        } else {
          this.message.error('查询面板稽核项异常');
        }
      });
    } else {
      this.message.info('未配置稽核项信息查询接口，请联系管理员！');
    }
  }
  auditItemChange(item) {
    this.itemConditionDisplayText = item.name;
    this.itemConditionId = item.id;
    this.automation.itemId = item.id;
    this.automation.itemName = item.name;
    this.itemConditionVisible = false;
    this.packageData();
  }
  statusConditionChange(item) {
    this.statusConditionCode = item.code;
    this.statusDisplayText = item.name;
    this.automation.auditStatus = item.code;
    this.statusConditionVisible = false;
    this.packageData();
  }

  // 分组变更
  groupConditionChange(item) {
    this.groupConditionDisplayText = item.title;
    this.groupConditionId = item.id;
    this.automation.groupId = item.id;
    this.groupConditionVisible = false;
    this.packageData();
  }
  // 弹窗创建任务
  openTaskDialog() {
    this.isVisible = true;
  }

  // 弹窗确定事件
  handleOk() {
    this.pulseCard.onSubmit();
    this.isVisible = false;
  }
  // 弹窗关闭事件
  handleCancel() {
    this.isVisible = false;
  }
  // 获取任务创建数据
  getTaskIntegrationData(event) {
    // this.backFillData = event;
    const obj: any = {};
    event.forEach((item, index) => {
      let mapObj: any;
      if (typeof item.mappingValue === 'string') {
        switch (item.type) {
          case 'dropdown':
            mapObj = {
              'fixedValue': {
                'ids': [item.mappingValue]
              }
            };
            break;
          case 'select':
            mapObj = {
              'fixedValue': {
                'option': item.mappingValue
              }
            };
            break;
          case 'button':
            mapObj = {
              'fixedValue': {
                'original': item.mappingValue
              }
            };
            break;
        }
      }
      if (item.type === 'dropdown' || item.type === 'select' || item.type === 'button') {
        obj[item.id] = mapObj;
      } else {
        const mpArr = [];
        item.mappingValue.forEach((m, i) => {
          mapObj = {
            'type': 'field',
            'sourceField': {
              'id': m.id,
              'type': m.type ? m.type : 'text',
              'title': m.title
            }
          };
          mpArr.push(mapObj);
        });
        mpArr.unshift({'type': 'text', 'text': item.mappingFirstValue});
        mpArr.push({'type': 'text', 'text': item.mappingEndValue});
        obj[item.id] = {
          'targetField': {
            'id': item.id,
            'title': item.title,
            'type': item.type,
          },
          'mappingParts': mpArr
        };
      }
      this.automation.taskMapping['mappingConfig'] = obj;
    });
    this.packageData();
  }

  // 组件提交数据
  packageData() {
    this.automation.instanceDescription = '监听到 ' + this.boardConditionDisplayText + ' 的 ' + this.itemConditionDisplayText + ' 的状态为 '
      + this.statusDisplayText + ' 时，在' + this.groupConditionDisplayText + '中，创建任务';
    console.log(this.automation);
    this.nfDataChange.emit(this.automation);
  }

  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus(): boolean {
    return this.boardConditionId &&
      this.itemConditionId && this.statusConditionCode &&
      this.groupConditionId &&
      JSON.stringify(this.automation.taskMapping) !== '{}';
  }
}
